import { SearchX } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { LucideIcon } from 'lucide-react'
import { ErrorState } from '@/components/shared/ErrorState'
import { ROUTES } from '@/constants/routeConstants.ts'

export interface NotFoundPageData {
  icon: LucideIcon
  titleKey: string
  subtitleKey: string
  ctaLabelKey: string
  ctaTo: string
}

export const NotFoundPage = ({ data }: { data?: unknown }) => {
  const { t } = useTranslation()
  const {
    icon: Icon = SearchX,
    titleKey = 'errors.page.notFoundTitle',
    subtitleKey = 'errors.page.notFoundSubtitle',
    ctaLabelKey = 'errors.page.backHome',
    ctaTo = ROUTES.ROOT,
  } = (data as NotFoundPageData | undefined) ?? {}

  return (
    <ErrorState
      icon={Icon}
      title={t(titleKey)}
      subtitle={t(subtitleKey)}
      ctaLabel={t(ctaLabelKey)}
      ctaTo={ctaTo}
    />
  )
}
